export const bookQueryKey = "books";

export const bookService = {
  async fetchBooks(
    take: number = 50,
    page: number = 1,
    sortBy: string = "createdAt",
    genres: string[] = []
  ) {
    const genresParam = genres.map(encodeURIComponent).join(",");

    const response = await fetch(
      `/api/books?take=${take}&page=${page}&sortBy=${sortBy}&genres=${genresParam}`
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch books");
    }

    return response.json();
  },

  async fetchBookSlugs() {
    const response = await fetch(`/api/books/slugs`);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch book slugs");
    }
    return response.json();
  },
};
